"use client"
/* */
import { Item } from './Item.mjs';

class ItemCollection {
  list;
  constructor(list) {
    this.list = list;
  }
  get entries() {
    return this.list.reactTable.table.getRowModel().rows.map((r) => Item.fromRow(this, r));
  }
}

export { ItemCollection };
//# sourceMappingURL=ItemCollection.mjs.map
